import { Button, Form, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SaveOutlined } from '@ant-design/icons';
import { TariffForm, TariffFormValues, TariffPeriodFormValues } from '../Form';
import { Periods, TariffUpsertParams, useTariffCreate } from '../../../../hooks/api/tariffs';
import SinglePageContainer from '../../../Common/SinglePageContainer';
import { toBerlinStartOfDayISO, toBerlinEndOfDayISO } from '../../../../utils/date';

export default function TariffCreatePage() {
  const navigate = useNavigate();
  const createTariff = useTariffCreate();
  const [form] = Form.useForm<TariffFormValues>();

  const tariffIdWatch = Form.useWatch('tariffId', form);

  const handleSubmit = async (values: TariffFormValues) => {
    const payload: TariffUpsertParams = {
      ...values,
      name: values.name.trim(),
      tariffId: Number(values.tariffId),
      isActive: values.isActive ?? true,
      isPriceOverviewVisible: values.isPriceOverviewVisible ?? false,
      periods: (values.periods ?? []).map(({ startDate, endDate, ...rest }) => {
        const data: Partial<TariffPeriodFormValues> = {
          ...rest,
        };

        if (startDate) {
          data.startDate = toBerlinStartOfDayISO(startDate);
        }

        if (endDate) {
          data.endDate = toBerlinEndOfDayISO(endDate);
        }

        return data as Periods;
      }),
    };

    try {
      await createTariff.fetch(payload).then((res) => {
        if (res?.tariffId) {
          message.success('Tariff has been created successfully');
          navigate(`/tariffs/${res?.id}/edit`);
        }
      });
    } catch (error: any) {
      message.error(error?.message);
    }
  };

  return (
    <SinglePageContainer
      title="Create Tariff"
      extra={(
        <Button
          onClick={() => form.submit()}
          icon={<SaveOutlined />}
          loading={createTariff.loading}
          disabled={Number(tariffIdWatch) === 0}
        >
          Save
        </Button>
      )}
    >
      <div style={{ maxWidth: 760 }}>
        <TariffForm
          form={form}
          onSubmit={handleSubmit}
        />
      </div>
    </SinglePageContainer>
  );
}
